module.exports = __webpack_public_path__ + "resources/img/img_kollus_live_commerce_service1_m.965f167fc684597c5497cb7a119149ee.png";